export default "__VITE_ASSET__Dyav4TQo__"